// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ProductionPlanning_infoBox__kimRc {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 10px 14px;
  background: #eff6ff;
  border: 1px solid #bfdbfe;
  border-radius: 8px;
  color: #1e40af;
  font-size: 13px;
  line-height: 1.5;
}
.ProductionPlanning_infoBox__kimRc svg {
  flex-shrink: 0;
  margin-top: 2px;
}

.ProductionPlanning_chip__EHLDw {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 10px;
  font-size: 11px;
  font-weight: 600;
  white-space: nowrap;
}

.ProductionPlanning_statusBadge__9pWOQ {
  display: inline-block;
  padding: 2px 10px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
}

.ProductionPlanning_statusSelect__Ejbd- {
  border: 1px solid var(--m-border-color, #e5e7eb);
  border-radius: 6px;
  padding: 4px 8px;
  font-size: 12px;
  font-weight: 600;
  background: transparent;
  cursor: pointer;
  outline: none;
}
.ProductionPlanning_statusSelect__Ejbd-:focus {
  border-color: var(--m-primary, #6366f1);
}

.ProductionPlanning_progressWrap__MRG9y {
  display: flex;
  align-items: center;
  gap: 6px;
}

.ProductionPlanning_progressTrack__nILCL {
  flex: 1 1;
  height: 7px;
  border-radius: 4px;
  background: var(--m-border-color, #e5e7eb);
  overflow: hidden;
}

.ProductionPlanning_progressFill__c1IFV {
  height: 100%;
  border-radius: 4px;
  transition: width 0.4s;
}

.ProductionPlanning_progressPct__EDKcz {
  font-size: 11px;
  color: var(--m-text-subtle, #6b7280);
  min-width: 30px;
}

.ProductionPlanning_bomDetail__sb-4p {
  padding: 14px 20px;
}

.ProductionPlanning_bomDetailTitle__j-urk {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  font-weight: 600;
  color: var(--m-text, #374151);
  margin-bottom: 10px;
}

.ProductionPlanning_bomTable__PEfxl {
  width: 100%;
  border-collapse: collapse;
  font-size: 12px;
}
.ProductionPlanning_bomTable__PEfxl th {
  text-align: left;
  padding: 6px 10px;
  background: var(--m-background, #f3f4f6);
  color: var(--m-text-subtle, #6b7280);
  font-weight: 600;
  border-bottom: 1px solid var(--m-border-color, #e5e7eb);
}
.ProductionPlanning_bomTable__PEfxl td {
  padding: 7px 10px;
  border-bottom: 1px solid var(--m-border-color-subtle, #f0f0f0);
  vertical-align: middle;
}
.ProductionPlanning_bomTable__PEfxl tr:last-child td {
  border-bottom: none;
}

.ProductionPlanning_statsRow__4dvju {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  margin-bottom: 1rem;
  margin-top: 1rem;
}

.ProductionPlanning_statsCard__Z5i6a {
  flex: 1 1;
  min-width: 180px;
}

.ProductionPlanning_modeToggle__D4y\\+J {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.ProductionPlanning_modeToggleLabel__5mAgO {
  font-size: 13px;
  font-weight: 600;
  color: var(--m-text, #374151);
}

.ProductionPlanning_modeToggleBtns__zN9FQ {
  display: flex;
  gap: 6px;
}

.ProductionPlanning_feasBanner__6g5lI {
  display: flex;
  align-items: flex-start;
  gap: 14px;
  padding: 14px 18px;
  border: 2px solid;
  border-radius: 10px;
  margin-top: 1rem;
  margin-bottom: 1rem;
}`, "",{"version":3,"sources":["webpack://./src/views/pages/ProductionPlanning/ProductionPlanning.module.scss"],"names":[],"mappings":"AACA;EACE,aAAA;EACA,uBAAA;EACA,SAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AAAF;AAEE;EACE,cAAA;EACA,eAAA;AAAJ;;AAKA;EACE,qBAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;AAFF;;AAKA;EACE,qBAAA;EACA,iBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;AAFF;;AAMA;EACE,gDAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,eAAA;EACA,aAAA;AAHF;AAKE;EACE,uCAAA;AAHJ;;AAQA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AALF;;AAQA;EACE,SAAA;EACA,WAAA;EACA,kBAAA;EACA,0CAAA;EACA,gBAAA;AALF;;AAQA;EACE,YAAA;EACA,kBAAA;EACA,sBAAA;AALF;;AAQA;EACE,eAAA;EACA,oCAAA;EACA,eAAA;AALF;;AASA;EACE,kBAAA;AANF;;AASA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,gBAAA;EACA,6BAAA;EACA,mBAAA;AANF;;AASA;EACE,WAAA;EACA,yBAAA;EACA,eAAA;AANF;AAQE;EACE,gBAAA;EACA,iBAAA;EACA,wCAAA;EACA,oCAAA;EACA,gBAAA;EACA,uDAAA;AANJ;AASE;EACE,iBAAA;EACA,8DAAA;EACA,sBAAA;AAPJ;AAUE;EACE,mBAAA;AARJ;;AAaA;EACE,aAAA;EACA,eAAA;EACA,SAAA;EACA,mBAAA;EACA,gBAAA;AAVF;;AAaA;EACE,SAAA;EACA,gBAAA;AAVF;;AAcA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;AAXF;;AAcA;EACE,eAAA;EACA,gBAAA;EACA,6BAAA;AAXF;;AAcA;EACE,aAAA;EACA,QAAA;AAXF;;AAeA;EACE,aAAA;EACA,uBAAA;EACA,SAAA;EACA,kBAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;AAZF","sourcesContent":["// ─── Info Box ─────────────────────────────────────────────────────────────────\n.infoBox {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  padding: 10px 14px;\n  background: #eff6ff;\n  border: 1px solid #bfdbfe;\n  border-radius: 8px;\n  color: #1e40af;\n  font-size: 13px;\n  line-height: 1.5;\n\n  svg {\n    flex-shrink: 0;\n    margin-top: 2px;\n  }\n}\n\n// ─── Chips / Badges ───────────────────────────────────────────────────────────\n.chip {\n  display: inline-block;\n  padding: 2px 8px;\n  border-radius: 10px;\n  font-size: 11px;\n  font-weight: 600;\n  white-space: nowrap;\n}\n\n.statusBadge {\n  display: inline-block;\n  padding: 2px 10px;\n  border-radius: 12px;\n  font-size: 12px;\n  font-weight: 600;\n  white-space: nowrap;\n}\n\n// ─── Inline status select ────────────────────────────────────────────────────\n.statusSelect {\n  border: 1px solid var(--m-border-color, #e5e7eb);\n  border-radius: 6px;\n  padding: 4px 8px;\n  font-size: 12px;\n  font-weight: 600;\n  background: transparent;\n  cursor: pointer;\n  outline: none;\n\n  &:focus {\n    border-color: var(--m-primary, #6366f1);\n  }\n}\n\n// ─── Progress bar ────────────────────────────────────────────────────────────\n.progressWrap {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.progressTrack {\n  flex: 1;\n  height: 7px;\n  border-radius: 4px;\n  background: var(--m-border-color, #e5e7eb);\n  overflow: hidden;\n}\n\n.progressFill {\n  height: 100%;\n  border-radius: 4px;\n  transition: width 0.4s;\n}\n\n.progressPct {\n  font-size: 11px;\n  color: var(--m-text-subtle, #6b7280);\n  min-width: 30px;\n}\n\n// ─── BOM expandable detail ────────────────────────────────────────────────────\n.bomDetail {\n  padding: 14px 20px;\n}\n\n.bomDetailTitle {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--m-text, #374151);\n  margin-bottom: 10px;\n}\n\n.bomTable {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 12px;\n\n  th {\n    text-align: left;\n    padding: 6px 10px;\n    background: var(--m-background, #f3f4f6);\n    color: var(--m-text-subtle, #6b7280);\n    font-weight: 600;\n    border-bottom: 1px solid var(--m-border-color, #e5e7eb);\n  }\n\n  td {\n    padding: 7px 10px;\n    border-bottom: 1px solid var(--m-border-color-subtle, #f0f0f0);\n    vertical-align: middle;\n  }\n\n  tr:last-child td {\n    border-bottom: none;\n  }\n}\n\n// ─── Shortage stat cards row ───────────────────────────────────────────────────\n.statsRow {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 1rem;\n  margin-bottom: 1rem;\n  margin-top: 1rem;\n}\n\n.statsCard {\n  flex: 1;\n  min-width: 180px;\n}\n\n// ─── Shortage mode toggle ─────────────────────────────────────────────────────\n.modeToggle {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n.modeToggleLabel {\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--m-text, #374151);\n}\n\n.modeToggleBtns {\n  display: flex;\n  gap: 6px;\n}\n\n// ─── Shortage feasibility banner ──────────────────────────────────────────────\n.feasBanner {\n  display: flex;\n  align-items: flex-start;\n  gap: 14px;\n  padding: 14px 18px;\n  border: 2px solid;\n  border-radius: 10px;\n  margin-top: 1rem;\n  margin-bottom: 1rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"infoBox": `ProductionPlanning_infoBox__kimRc`,
	"chip": `ProductionPlanning_chip__EHLDw`,
	"statusBadge": `ProductionPlanning_statusBadge__9pWOQ`,
	"statusSelect": `ProductionPlanning_statusSelect__Ejbd-`,
	"progressWrap": `ProductionPlanning_progressWrap__MRG9y`,
	"progressTrack": `ProductionPlanning_progressTrack__nILCL`,
	"progressFill": `ProductionPlanning_progressFill__c1IFV`,
	"progressPct": `ProductionPlanning_progressPct__EDKcz`,
	"bomDetail": `ProductionPlanning_bomDetail__sb-4p`,
	"bomDetailTitle": `ProductionPlanning_bomDetailTitle__j-urk`,
	"bomTable": `ProductionPlanning_bomTable__PEfxl`,
	"statsRow": `ProductionPlanning_statsRow__4dvju`,
	"statsCard": `ProductionPlanning_statsCard__Z5i6a`,
	"modeToggle": `ProductionPlanning_modeToggle__D4y+J`,
	"modeToggleLabel": `ProductionPlanning_modeToggleLabel__5mAgO`,
	"modeToggleBtns": `ProductionPlanning_modeToggleBtns__zN9FQ`,
	"feasBanner": `ProductionPlanning_feasBanner__6g5lI`
};
export default ___CSS_LOADER_EXPORT___;
